import { render, staticRenderFns } from "./PrimaryEmployment.vue?vue&type=template&id=372c0c70"
import script from "./PrimaryEmployment.vue?vue&type=script&lang=js"
export * from "./PrimaryEmployment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports